import styled, { css } from 'styled-components';
import { FlexContainer, Layout, Modals, Text, Tooltip as Tooltip_ } from '@taxdown/piccolo-web';
import ThreeColLayout_ from 'Components/Layouts/ThreeColLayout';
import { DESKTOP_EXTRA_SMALL_WIDTH, MOBILE_WIDTH } from 'Styles/variables/sizes';

export const ThreeColLayout = styled(ThreeColLayout_)`
  @media screen and (max-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    grid-template-columns: 1fr;
    > div:first-child {
      order: 2;
    }
  }
`;

export const Body = styled(FlexContainer)`
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0;
`;

export const Price = styled(Text)`
  text-decoration: line-through;
`;

export const Success = styled.div`
  position: absolute;
  top: ${({ theme: { reference } }) => reference.dimension_04};
  right: ${({ theme: { reference } }) => reference.dimension_08};
`;

export const TitleContainer = styled<{ isDesktop: boolean }>(FlexContainer)`
  width: 358px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;
export const PreviousYearContainer = styled(Layout.Wrap)`
  width: 358px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const Container = styled(FlexContainer)`
  border: 1px solid ${({ theme: { colors } }) => colors.blue_5};
  border-bottom: none;
  border-radius: ${({ theme: { system } }) =>
    `${system.fds_sys_borderradius_L} ${system.fds_sys_borderradius_L} 0 0`};
  padding: ${({ theme: { reference } }) => reference.dimension_16};
  height: 100%;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const BannerContainer = styled(Layout.Wrap)`
  width: 358px;
  background-color: ${({ theme: { system } }) => system.background.fds_sys_color_background_cold};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const ButtonBox = styled(FlexContainer)<{ checked: boolean }>`
  position: relative;
  width: 358px;
  border: ${({ theme: { system, components }, checked }) =>
    `
      ${system.fds_sys_borderwidth_S} solid ${
        checked
          ? system.accent.fds_sys_color_accent_cold
          : components.inputs.fds_c_input_bordercolor
      }
    `};
  border-radius: ${({ theme: { sizing } }) => sizing.fds_borderradius_L};
  padding: ${({ theme: { reference } }) => reference.dimension_16};
  background: ${({ theme: { components }, checked }) =>
    checked && components.inputs.fds_c_input_color_selected};
  box-shadow: ${({ theme: { system }, checked }) => {
    const { x, y, blur, spread, color } = system.fds_sys_embed_M;
    return checked && `inset ${x} ${y} ${blur} ${spread} ${color}`;
  }};
  transition:
    box-shadow 1.5s cubic-bezier(0, 0.8, 0.2, 1),
    border-color 1.5s cubic-bezier(0, 0.8, 0.2, 1);

  @keyframes gradient {
    0% {
      background-position: 0% 0%;
    }

    100% {
      background-position: -100vw 0%;
    }
  }

  ${({ disabled, checked }) =>
    disabled
      ? css`
          opacity: ${({ theme: { system } }) => system.fds_sys_disabled_opacity_S};
          cursor: not-allowed;
        `
      : css`
          &:hover {
            box-shadow: ${({ theme: { system } }) => {
              const { x, y, blur, spread, color } = system.fds_sys_elevation_M;
              return checked
                ? `${x} ${y} ${blur} ${spread} ${color}, inset ${x} ${y} ${blur} ${spread} ${color}`
                : `${x} ${y} ${blur} ${spread} ${color}`;
            }};
            border-color: ${({ theme: { system, components } }) =>
              checked
                ? system.accent.fds_sys_color_accent_cold
                : components.cells.fds_c_cells_border_color_hover};
            transition:
              box-shadow 0.25s cubic-bezier(0, 0, 0.2, 2),
              border-color 0.25s cubic-bezier(0, 0, 0.2, 2);
          }
        `}
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const Tooltip = styled(Tooltip_)`
  button {
    padding: 0;
    width: auto;
    cursor: default;
  }
  > div:nth-child(2):before {
    left: 0%;
    transform: translateX(0);
  }
  > div:nth-child(2) {
    width: auto;
    transform: translateX(0);
    border-radius: 0;
  }
  @media screen and (max-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    :hover {
      > div:nth-child(2) {
        display: none;
      }
    }
  }
`;

export const Modal = styled(Modals.Centered)`
  #modal-info {
    > div > svg {
      width: 32px;
      height: 32px;
    }
  }
`;

export const BulletParagraph = styled(Text)`
  position: relative;
  padding-left: ${({ theme: { reference } }) => reference.dimension_24};

  &::before {
    content: '•';
    position: absolute;
    left: ${({ theme: { reference } }) => reference.dimension_08};
    color: ${({ theme: { colors } }) => colors.dark_500};
  }
`;

export const ButtonContainer = styled(FlexContainer)`
  height: 70px;
  width: 100%;
  position: sticky;
  bottom: 0;
  left: 0;
  background: ${({ theme: { colors } }) => colors.white};
  border: 1px solid ${({ theme: { colors } }) => colors.blue_5};
  border-radius: ${({ theme: { system } }) =>
    `0 0 ${system.fds_sys_borderradius_L} ${system.fds_sys_borderradius_L} `};
`;
